<template>
  <div id="app">
    <!-- page header -->
    <app-ai-header v-if="isAIPublish"></app-ai-header>
    <app-header v-else></app-header>

    <router-view></router-view>

    <aisee :show-complaint="!isAIPublish"></aisee>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppHeader from '@/components/Header/index'
import AppAiHeader from '@/components/AIHeader/index'
import Aisee from '@/components/Aisee'
import { isAIPublish } from '@/router'
import { TOKEN_KEY } from '@/utils/auth'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppAiHeader,
    Aisee,
  },
  data() {
    return {
      minHeight: 0,
      isAIPublish
    }
  },
  computed: {
    ...mapGetters(['hasLogin', 'token']),
  },
  mounted() {
    // 监听是否登录新账号
    window.addEventListener('storage', (e) => {
      if (e.key && e.key === TOKEN_KEY && this.hasLogin && this.token !== Number(e.newValue)) {
        console.log('token change', this.token, e.newValue)
        this.$alert.warning('您已在其他页面登录新的账号，请刷新页面', '提示', {
          showClose: false,
          confirmButtonText: '刷新',
          callback: (action) => {
            location.reload()
          }
        })
      }
    })
  }
}
</script>
